import { useAttachmentFieldCommit as useSharedFieldCommit } from '@features/Attachments/hooks/useAttachmentFieldCommit';
import { translate } from '@utils/i18n';
import { EDIT_MODAL_ERRORS_NS, WORK_ORDER_ATTACHMENTS_ENTITY_KEY } from '../constants';
import { updateWorkOrderAttachment } from '../services/workOrderAttachmentsApi';
/**
 * Work Order's binding of the shared single-field commit. `rowId` is the namespaced id, not a
 * primary key — it is what the list cache is keyed on, so the cache patch only lands if the same
 * value is passed through.
 */
export function useAttachmentFieldCommit(workOrderId, rowId) {
    return useSharedFieldCommit({
        entityKey: WORK_ORDER_ATTACHMENTS_ENTITY_KEY,
        ownerId: workOrderId,
        attachmentId: rowId,
        update: updateWorkOrderAttachment,
        genericErrorMessage: translate('generic', { namespace: EDIT_MODAL_ERRORS_NS })
    });
}
